import { Fn }			from "ts-base/fn";
import { Dates }		from "ts-base/dates";
import { Comparator }	from "ts-base/comparator";
import { DateOffset }	from "ts-base/time/dateOffset";

import { Textual }		from "@v3/data/textual";
import { Instant }		from "@v3/data/time/instant";
import { IsoDateTimeM }	from "@v3/data/time/isoDateTimeM";
import { IsoDateTimeS }	from "@v3/data/time/isoDateTimeS";
import { IsoDate }		from "@v3/data/time/isoDate";
import { IsoTimeM }		from "@v3/data/time/isoTimeM";
import { IsoTimeS }		from "@v3/data/time/isoTimeS";

// YYYY-MM-DD'T'hh:mm:ss.sss'Z'
export type IsoTimestampF	= Textual.Value<typeof Base>;

const Base	=
	Textual.regex(
		"IsoTimestampF",
		// TODO time allows day 29-31 in too many months
		/^\d{4}-(0[1-9]|1[0-2])-(0[1-9]|[12][0-9]|3[01])T([0-1][0-9]|2[0-3]):[0-5][0-9]:[0-5][0-9]\.\d{3}Z$/,
		"must be an iso-8601 datetime in YYYY-MM-DD'T'hh:mm:ss.sss'Z' format"
	);

namespace Extension {
	export const fromDate		= (it:Date):IsoTimestampF	=> Base.brand(it.toISOString());
	export const toDate			= (it:IsoTimestampF):Date	=> new Date(it);

	export const epoch			= fromDate(Dates.epoch);
	export const now			= ():IsoTimestampF => fromDate(Dates.now());

	export const fromInstant	= Fn.andThen(Instant.toDate, fromDate);
	export const toInstant		= Fn.andThen(toDate, Instant.fromDate);

	export const getIsoDateTimeM	= (it:IsoTimestampF):IsoDateTimeM	=> IsoDateTimeM.brand(it.substring(0, 16));
	export const getIsoDateTimeS	= (it:IsoTimestampF):IsoDateTimeS	=> IsoDateTimeS.brand(it.substring(0, 19));
	export const getIsoDate			= (it:IsoTimestampF):IsoDate		=> IsoDate.brand(it.substring(0, 10));
	export const getIsoTimeM		= (it:IsoTimestampF):IsoTimeM		=> IsoTimeM.brand(it.substring(11, 16));
	export const getIsoTimeS		= (it:IsoTimestampF):IsoTimeS		=> IsoTimeS.brand(it.substring(11, 19));

	export const laterOffset	= (self:IsoTimestampF, offset:DateOffset.Partial):IsoTimestampF	=> fromDate(Dates.utc.later(toDate(self),	offset));
	export const earlierOffset	= (self:IsoTimestampF, offset:DateOffset.Partial):IsoTimestampF	=> fromDate(Dates.utc.earlier(toDate(self),	offset));

	export const compare		= Comparator.builtinOf<IsoTimestampF>();
}

export const IsoTimestampF	= { ...Extension, ...Base };
